import { DataModel } from '@/ux-common/src/types/tree-view-types';

export const formatTraceDataInTreeFormat = (data: DataModel[]) => {
  // Step 1: normalize start times
  const updatedData = updateStartTime([...data]); // shallow clone to avoid mutations

  // Step 2: build a multi-root tree
  let res = list_to_tree(updatedData);

  // Step 3: insert row indices
  res = insertRowNumber(res);

  // Step 4: update start times again
  return updateStartTime(res);
};

const list_to_tree = (list: DataModel[]): DataModel[] => {
  const map = new Map<number | string, DataModel>();
  const roots: DataModel[] = [];

  // Create map and initialize children
  list.forEach((node) => {
    node.children = [];
    map.set(node.id, node);
  });

  // Build parent-child relationships
  list.forEach((node) => {
    if (node.parentId != null && map.has(node.parentId)) {
      const parent = map.get(node.parentId)!;
      parent.children!.push(node);
    } else {
      // either parentId null or missing → treat as root
      roots.push(node);
    }
  });

  return roots;
};

// we insert indexes to each row, to maintain the expand/collapse state in chart, when a row is collapsed, all its children are hidden and next row has its own index, not the next number.
const insertRowNumber = (
  data: DataModel[],
  indexRef = { value: 1 }
): DataModel[] => {
  data.forEach((d) => {
    d.index = indexRef.value++;
    if (d.children?.length) insertRowNumber(d.children, indexRef);
  });
  return data;
};

const updateStartTime = (data: DataModel[]): DataModel[] => {
  if (!data.length) return data;
  const lowestData = [...data].sort((a, b) =>
    a.startTime < b.startTime ? -1 : 1
  )[0];
  const lowestStart = new Date(lowestData.startTime).getTime();

  data.forEach((d) => {
    d.startms = new Date(d.startTime).getTime() - lowestStart;
  });

  return data;
};
